(function (window, document) {
  window.addEventListener('scroll', (e) => toggleFixedHeader(e, document));

  let sidebarToggles = document.querySelectorAll('._sidebar-toggle');
  if (sidebarToggles.length) sidebarToggles.forEach(toggle => toggle.addEventListener('click', () => toggleSidebar(document)));

  let sidebarCloseButtons = document.querySelectorAll('._sidebar-close');
  if (sidebarCloseButtons.length) sidebarCloseButtons.forEach(toggle => toggle.addEventListener('click', () => toggleSidebar(document, true)));

  let imageModalToggles = document.querySelectorAll('.kg-image, .article-image img');
  if (imageModalToggles.length) imageModalToggles.forEach(toggle => toggle.addEventListener('click', (e) => showImageModal(document, e)));

  let modalToggles = document.querySelectorAll('._modal');
  if (modalToggles.length) modalToggles.forEach(toggle => toggle.addEventListener('click', (e) => hideImageModal(document)));

  tippy('#menu-dropdown-company', {
    content: '<ul>' +
      '<li><a href="https://medialooks.com/about">About</a></li>' +
      '<li><a href="https://medialooks.com/partners">Partners</a></li>' +
      '<li><a href="https://medialooks.com/contacts">Contacts</a></li>' +
      '<li><a href="https://medialooks.com/documents">Documents</a></li>' +
      '<li><a href="https://medialooks.com/faq">Licensing FAQ</a></li>' +
      '</ul>',
    allowHTML: true,
    placement: 'bottom',
    theme: 'custom',
    interactive: true,
    arrow: false,
    delay: [0, 500],
  });

  tippy('#menu-main-dropdown-company', {
    content: '<ul>' +
      '<li><a href="https://medialooks.com/about">About</a></li>' +
      '<li><a href="https://medialooks.com/partners">Partners</a></li>' +
      '<li><a href="https://medialooks.com/contacts">Contacts</a></li>' +
      '<li><a href="https://medialooks.com/documents">Documents</a></li>' +
      '<li><a href="https://medialooks.com/faq">Licensing FAQ</a></li>' +
      '</ul>',
    allowHTML: true,
    placement: 'bottom',
    theme: 'custom-header',
    interactive: true,
    duration: 0,
    delay: [0, 500],
  });

  function toggleFixedHeader(e, document) {
    if (e.target !== document) return;

    let header = document.querySelector('#gh-head-fixed');
    if (!header) return;

    if (pageYOffset > 90) header.classList.add('-active');
    else header.classList.remove('-active');
  }

  function toggleSidebar(document, close = false) {
    let sidebarBlocks = document.querySelectorAll('._sidebar');
    if (!sidebarBlocks.length) return;
    sidebarBlocks.forEach(block => block.classList[close ? 'remove' : 'toggle']('-active'));
  }

  function showImageModal(document, e) {
    let modalBlocks = document.querySelectorAll('._modal'),
        modalImage = document.querySelector('._modal-image');

    if (!modalBlocks.length || !modalImage) return;
    modalImage.style.backgroundImage = `url(${e.target.src})`;
    modalImage.style.backgroundSize = 'contain';
    modalBlocks.forEach(block => block.classList.add('-active'));
  }

  function hideImageModal(document) {
    let modalBlocks = document.querySelectorAll('._modal');

    if (!modalBlocks.length) return;
    modalBlocks.forEach(block => block.classList.remove('-active'));
  }
})(window, document);